import { cva, type VariantProps } from 'class-variance-authority';
export { default as Badge } from './Badge.vue';
export const badgeVariants = cva(
  'inline-flex max-w-full items-center gap-1 rounded-sm border px-2 py-0.5 text-xs font-medium leading-5',
  {
    variants: {
      variant: {
        default: 'border-primary/10 bg-primary/10 text-primary',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        outline: 'border-border text-foreground',
        destructive: 'border-transparent bg-red-50 text-red-700',
        success: 'border-transparent bg-emerald-50 text-emerald-700',
        warning: 'border-transparent bg-amber-50 text-amber-800',
      },
    },
    defaultVariants: { variant: 'secondary' },
  }
);
export type BadgeVariants = VariantProps<typeof badgeVariants>;
